module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_5_TECNOLÓGICO.3c7e3936.jpg";